import React from "react";

export default (props) => {
    const estilo = props.style || {};
    return (
        <section className="content" style={{ ...estilo, margin: "12px 8px", backgroundColor: "#f0f1f5" }}>
            {props.children}
        </section>
    );
};
